import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  styled,
  RadioGroup,
  Radio,
  FormControlLabel,
  Switch,
  CircularProgress,
} from "@mui/material";
import { useSelector } from "react-redux";
import IOSSwitch from "../formComponents/IOSSwitch";
import FormHelperText from "@mui/joy/FormHelperText";
import ImageUpload from "./ImageUpload";

const CustomTextarea = styled(TextField)(({ theme }) => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    border: "1px solid #414466",
    borderRadius: "8px",
    color: "white",
    "&:hover": {
      backgroundColor: "transparent",
      border: "1px solid #414466",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      border: "1px solid #414466",
      outline: "none",
    },

    [theme.breakpoints.down("md")]: {
      padding: "7.5px 9px",
    },

    "& .MuiInputBase-input": {
      // maxHeight: "70px",
      [theme.breakpoints.down("md")]: {
        maxHeight: "52px",

        padding: "0px",
      },
    },
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const StyledRadio = styled(Radio)(({ theme }) => ({
  color: "white",
  padding: "0",
  "&.Mui-checked": {
    color: "#343759",
  },
  "&.MuiRadio-root": {
    padding: "0",
  },
}));

const StyledRadioD = styled(Radio)(({ theme }) => ({
  display: "none",
}));

const StyledRadioLable = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== "checked",
})(({ theme, checked }) => ({
  gap: "10px",
  alignItems: "center",
  margin: theme.spacing(1),
  padding: "15px 20px",
  backgroundColor: checked ? "#FFCD1F" : "#343759",
  borderRadius: "40px",
  cursor: "pointer",

  color: checked ? "black" : "#ffffff",
  padding: "15px 20px",
  [theme.breakpoints.down("md")]: {
    padding: "8px 11px",
    fontSize: "14px",
  },

  textTransform: "none",

  "& .Mui-checked ": {
    backgroundColor: "#FFCD1F",
    color: "black",
  },

  "& .MuiFormControlLabel-label": {
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
    },
  },
}));

const categories = [
  { id: 1, name: "Men's" },
  { id: 2, name: "Women's" },
  { id: 3, name: "Boy's" },
  { id: 4, name: "Girl's" },
  { id: 5, name: "Vet's" },
];

const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

const Step1 = ({ formik, edited, from }) => {
  useEffect(() => {
    "";
  }, [formik.touched]);
  const goalCategories = useSelector((state) => state.goalCategories);

  const [categories, setCategories] = useState(null);

  const [youthSubCat, setYouthSubCat] = useState([]);
  const [youthAge, setYouthAge] = useState([]);

  useEffect(() => {
    if (goalCategories.loading) {
      setCategories("loading");
    } else {
      if (from == "Youth_Football") {
        setCategories(
          goalCategories.data.data.filter(
            (cat) => cat.name == "Youth Football",
          ),
        );
      } else {
        setCategories(goalCategories.data.data);
      }
    }

    if (!goalCategories.loading) {
      setYouthSubCat(
        goalCategories?.data?.data
          ?.filter((cat) => cat.enable)
          .find((cat) => cat.id == "6")?.subCategory || [],
      );

      setYouthAge(
        goalCategories?.data?.data
          ?.filter((cat) => cat.enable)
          .find((cat) => cat.id == "6")
          ?.subCategory?.find((subc) => subc.id == formik.values.subCategory)
          ?.childSubCategories || [],
      );
    }
  }, [goalCategories]);

  useEffect(() => {
    setYouthAge(
      goalCategories?.data?.data
        ?.filter((cat) => cat.enable)
        .find((cat) => cat.id == "6")
        ?.subCategory?.find((subc) => subc.id == formik.values.subCategory)
        ?.childSubCategories || [],
    );
  }, [formik.values.subCategory]);


  return (
    <>
      <Box className="profile-wrapper-outter">
        <Box className="profile-wrapper">
          <ImageUpload formik={formik} edited={edited} />
        </Box>
        <Box className="profile-label">
          {/* <Typography component={"span"}>Upload image/club logo</Typography> */}
        </Box>
      </Box>

      <Box className="title form-control">
        <Typography className="label">Title</Typography>
        <CustomTextarea
          id="outlined-multiline-static"
          rows={5}
          multiline
          placeholder="Describe your goal in 6 words"
          variant="outlined"
          value={formik.values.title}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          name="title"
        />

        {formik.touched.title && formik.errors.title ? (
          <FormHelperText sx={{ color: "red" }}>
            {formik.touched.title && formik.errors.title}
          </FormHelperText>
        ) : (
          ""
        )}
      </Box>

      <Box className="category form-control">
        <Typography className="label">Video Category</Typography>
        <RadioGroup name="category" row>
          {Array.isArray(categories) && categories.length > 0 ? (
            categories
              ?.filter((cat) => cat.enable)
              .map((category, index) => (
                <StyledRadioLable
                  control={
                    <StyledRadioD
                      value={category.id}
                      onChange={formik.handleChange}
                      // onBlur={formik.handleBlur}
                      checked={formik.values.category === category.id}
                    />
                  }
                  label={category.name}
                  checked={formik.values.category === category.id}
                  key={category.id}
                  onClick={() => {
                    formik.setFieldValue("category", category.id);
                    formik.setFieldValue("subCategory", null);
                    formik.setFieldValue("childCategory", null);
                    formik.setFieldTouched("category", true);
                    // formik.setFieldTouched("category", true);
                  }}
                />
              ))
          ) : (
            <CircularProgress sx={{ color: "#ef364e" }} />
          )}
        </RadioGroup>
        {formik.touched.category && formik.errors.category ? (
          <FormHelperText sx={{ color: "red" }}>
            {formik.touched.category && formik.errors.category}
          </FormHelperText>
        ) : (
          ""
        )}
      </Box>
      {formik.values.category == "6" && (
        <>
          <Box className="category form-control">
            <Typography className="label">Youth Category</Typography>
            <RadioGroup name="subCategory" row>
              {goalCategories.loading ? (
                <CircularProgress sx={{ color: "#ef364e" }} />
              ) : youthSubCat?.length > 0 ? (
                youthSubCat?.map((category, index) => (
                  <StyledRadioLable
                    control={
                      <StyledRadioD
                        value={category.id}
                        onChange={formik.handleChange}
                        checked={formik.values.subCategory === category.id}
                      />
                    }
                    label={category.name}
                    checked={formik.values.subCategory === category.id}
                    key={category.id}
                    onClick={() => {
                      formik.setFieldValue("subCategory", category.id);
                    }}
                  />
                ))
              ) : null}
              {/* {goalCategories.loading ? (
                <CircularProgress sx={{ color: "#ef364e" }} />
              ) : goalCategories.data?.data?.length > 0 ? (
                goalCategories.data.data
                  ?.filter((cat) => cat.enable)
                  .find((cat) => cat.id == "6")
                  ?.subCategory?.map((category, index) => (
                    <StyledRadioLable
                      control={
                        <StyledRadioD
                          value={category.id}
                          onChange={formik.handleChange}
                          checked={formik.values.subCategory === category.id}
                        />
                      }
                      label={category.name}
                      checked={formik.values.subCategory === category.id}
                      key={category.id}
                      onClick={() => {
                        formik.setFieldValue("subCategory", category.id);
                      }}
                    />
                  ))
              ) : null} */}
            </RadioGroup>
            {formik.touched.subCategory && formik.errors.subCategory ? (
              <FormHelperText sx={{ color: "red" }}>
                {formik.touched.subCategory && formik.errors.subCategory}
              </FormHelperText>
            ) : (
              ""
            )}
          </Box>
          {youthAge?.length > 0 && (
            <Box className="category form-control">
              <Typography className="label">Age Category</Typography>
              <RadioGroup name="subCategory" row>
                {goalCategories.loading ? (
                  <CircularProgress sx={{ color: "#ef364e" }} />
                ) : goalCategories.data?.data?.length > 0 ? (
                  youthAge?.map((category, index) => (
                    <StyledRadioLable
                      control={
                        <StyledRadioD
                          value={category.id}
                          onChange={formik.handleChange}
                          checked={formik.values.childCategory === category.id}
                        />
                      }
                      label={category.name}
                      checked={formik.values.childCategory === category.id}
                      key={category.id}
                      onClick={() => {
                        formik.setFieldValue("childCategory", category.id);
                        formik.setFieldTouched("childCategory", true);
                      }}
                    />
                  ))
                ) : null}
                {/* goalCategories.data?.data?.length > 0 ? (
                  goalCategories.data.data
                    ?.filter((cat) => cat.enable)
                    .find((cat) => cat.id == "6")
                    ?.subCategory?.find(
                      (subc) => subc.id == formik.values.subCategory,
                    )
                    ?.childSubCategories?.map((category, index) => (
                      <StyledRadioLable
                        control={
                          <StyledRadioD
                            value={category.id}
                            onChange={formik.handleChange}
                            checked={
                              formik.values.childCategory === category.id
                            }
                          />
                        }
                        label={category.name}
                        checked={formik.values.childCategory === category.id}
                        key={category.id}
                        onClick={() => {
                          formik.setFieldValue("childCategory", category.id);
                          formik.setFieldTouched("childCategory", true);
                        }}
                      />
                    ))
                ) : null} */}
              </RadioGroup>
              {formik.touched.childCategory && formik.errors.childCategory ? (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.touched.childCategory && formik.errors.childCategory}
                </FormHelperText>
              ) : (
                ""
              )}
            </Box>
          )}
        </>
      )}

      <Box className="category form-control">
        <Typography className="label">Video From</Typography>
        <RadioGroup name="from_uk" row>
          {[
            { name: "UK", id: 1 },
            { name: "International", id: 0 },
          ].map((category) => (
            <StyledRadioLable
              control={
                <StyledRadio
                  value={category.id}
                  onChange={(e) => {
                    if (e.target.checked)
                      formik.setFieldValue("from_uk", category.id);
                  }}
                  onBlur={formik.handleBlur}
                  checked={formik.values.from_uk === category.id}
                />
              }
              label={category.name}
              checked={formik.values.from_uk === category.id}
              key={category.id}
              onClick={() => {
                formik.setFieldValue("from_uk", category.id);
                formik.setFieldTouched("from_uk", true);
              }}
            />
          ))}
        </RadioGroup>
        {formik.touched.from_uk && formik.errors.from_uk ? (
          <FormHelperText sx={{ color: "red" }}>
            {formik.touched.from_uk && formik.errors.from_uk}
          </FormHelperText>
        ) : (
          ""
        )}
      </Box>

      <Box className="category form-control">
        <Typography className="label">City/Town</Typography>
        <CustomTextarea
          variant="outlined"
          name="region"
          // select
          value={formik.values.region}
          onChange={formik.handleChange}
          placeholder="Enter City/Town"
          onBlur={formik.handleBlur}
        ></CustomTextarea>
        {formik.touched.region && formik.errors.region ? (
          <FormHelperText sx={{ color: "red" }}>
            {formik.touched.region && formik.errors.region}
          </FormHelperText>
        ) : (
          ""
        )}
      </Box>

      <Box className="category form-control">
        <Typography className="label">Name of Football Club</Typography>
        <CustomTextarea
          variant="outlined"
          name="club"
          value={formik.values.club}
          onChange={formik.handleChange}
          placeholder="Enter Football Club Name"
          onBlur={formik.handleBlur}
        />
        {formik.touched.club && formik.errors.club ? (
          <FormHelperText sx={{ color: "red" }}>
            {formik.errors.club}
          </FormHelperText>
        ) : (
          ""
        )}
      </Box>

      <Box className="category form-control">
        <Typography className="label">Full Name of Goal Scorer</Typography>
        <CustomTextarea
          variant="outlined"
          name="goal_scorer"
          value={formik.values.goal_scorer}
          onChange={formik.handleChange}
          placeholder="Enter Goal Scorer Name"
          onBlur={formik.handleBlur}
        />
        {formik.touched.goal_scorer && formik.errors.goal_scorer ? (
          <FormHelperText sx={{ color: "red" }}>
            {formik.errors.goal_scorer}
          </FormHelperText>
        ) : (
          ""
        )}
      </Box>

      <Box className="category form-control">
        <Box className="comments-switch">
          <Typography className="label" sx={{ marginBottom: "0" }}>
            Keep the comment section {formik.values.comments ? "on" : "off"}
          </Typography>
          <IOSSwitch
            sx={{ m: 1 }}
            checked={formik.values.comments}
            onChange={(e) => {
              formik.setFieldValue("comments", e.target.checked);
            }}
          />
        </Box>
      </Box>
    </>
  );
};

export default Step1;
